/** Подключение подсказки D-02 к состоянию приложения. */
import { useAppStore } from '../../model/app-store'
import { ShortcutsSheet } from './ShortcutsSheet'

export function ShortcutsHost(): React.ReactElement {
  const open = useAppStore((s) => s.shortcutsOpen)
  const setOpen = useAppStore((s) => s.setShortcutsOpen)

  return <ShortcutsSheet open={open} onClose={() => setOpen(false)} />
}
